<app-scanner-demo (onClose)="onScannerClose()"></app-scanner-demo>
